import { Microfrontend } from '../microfrontend/Microfrontend';
class VanillaTranslator {
    exposeMicrofrontend(component, microfrontendOptions) {
        const microfrontendFactory = new Microfrontend({
            microfrontendOptions,
            mount: (rootElement) => {
                rootElement.innerHTML = component();
            },
            unmount: (rootElement) => {
                rootElement.innerHTML = '';
            },
        });
        return microfrontendFactory;
    }
    createMicrofrontend(microfrontend, rootElement) {
        microfrontend.mount(rootElement);
    }
}
export const vanillaTranslator = new VanillaTranslator();
